window.FBTCalled = false;
window.DealBarCalled = false;
window.EliteProtection_Init = false;
class CartRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', (event) => {
      event.preventDefault();
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      if(this.classList.contains("gift-remove")){
        cartItems.updateQuantity_For_Gift(this.dataset.variant,this.dataset.index);
      }else{
        cartItems.updateQuantity(this.dataset.index, 0);
        GA4.remove_from_cart(window.cart.items[this.dataset.index-1],this.getAttribute('unbxdparam_sku'),this.dataset.quantity);
      }
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement =
      document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener('change', debouncedOnChange.bind(this));
    this.FBT();
    this.DealBar();
    this.FreeGiftCheck();
  }

  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.source === 'cart-items') {
        return;
      }
      this.onCartUpdate();
    });
  }

  FreeGiftCheck(){
    var _this = this;
    fetch('/cart.js').then(res => res.json()).then((cart) => {
      localStorage.setItem("cart_data",JSON.stringify(cart));
      EliteProtection.InitWithCart(cart);
      if(window.EliteProtection_Init == false){
        window.EliteProtection_Init = true;
        this.Checkproduct(cart);
      }
      window.cart = cart;
      var Items = cart.items,
          UnlockedItem = [],
          ExfreeItem = [],
          Arrayupdate = [],
          NeedtoRemove = [],
          NeedtoAdd = [],
          free_items_list = [],
          Rp = { updates: {} },
          onlygift = true,
          Needtoupdate = false,
          Product0 = 42185367355526,
          Product1 = parseInt($('#Product1').val()),
          Product2 = parseInt($('#Product2').val()),
          Product3 = parseInt($('#Product3').val()),
          Product4 = parseInt($('#Product4').val()),
          Product5 = 40622740897926,
          total_price = 0,
          $Ehp_total = 0,
          $oxygreens_status = false,
          $oxygreens_id,
          $disorder_ultimate = false,
          $nitro_tech = false,
          $max_shred_system = false,
          $dialed_carnage = false,
          $krupt = false,
          $mystery_rtd = 42176760479878,
          $free_rtd_count = 0,
          $rule1_5lb_products = [40153681920134,32194241419,41227692703878,32194241483,32194241547,39994868203654,32194241611,40038091489414,41369380683910,32194241739,41369353912454],
          $rule1_5lb = false,
          $switch_power_perform = false,
          $nexus_juicy_burst = false;
          // $FreeRawBar = 41274459455622;
          free_items_list.push(40622738931846); // this one is added to remove old free mixer automatically
      $('.cart-upsell-products .upsell-item').show();
      var $200_deal_found = false;
      var $400_deal_found = false;
      var $Rule_1_found = false;
      var $Rule_1_product;
      var $mystery_stack = 0;
      for(var i=0; i < Items.length;i++){
          var Item = Items[i];
          if(Item.handle != 'gift-card'){
            if(Item.properties && !Item.properties['_free-product'] && Item.product_type != "HIDE FROM SITE"){
              total_price += Item.final_line_price;
              onlygift = false;
            }
          }

          if(Item.product_id == 7421989388422){
            if(Item.properties && Item.properties['_custom-bundle-of-handle'] == 'mystery-product-stack'){
              $mystery_stack += Item.quantity;
            }
          }

          if(Item.id == $mystery_rtd){
            $free_rtd_count += Item.quantity;
          }
          if(Item.properties && Item.properties['_free-product']){
            $('.cart-upsell-products .upsell-item[data-handle='+Item.handle+']').hide();
          }
          // if(Item.properties && Item.properties['_200-deal-bar']){
          //   $200_deal_found = true;
          //   Product2 = Item.id;
          // }
          if(Item.properties && Item.properties['_400-deal-bar']){
            $400_deal_found = true;
            Product3 = Item.id;
          }
          if(Item.vendor == "EHP Labs" && Item.product_type != "HIDE FROM SITE"){
            $Ehp_total += Item.final_line_price;
          }
          if(Item.product_id == 7215456682118){
            $krupt = true;
          }
          if(Item.product_id == 7034705182854){
            $disorder_ultimate = true;
          }

          if(jQuery.inArray(Item.id,$rule1_5lb_products) > -1){
            $rule1_5lb = true;
          }

          if(Item.product_id == 7484516728966){
            $switch_power_perform = true
          }

          if(Item.id == 43120275193990){
            $nexus_juicy_burst = true
          }
          if(Item.product_id == 7546798932102){
            $oxygreens_status = true
            free_items_list.push(Item.id);
            $oxygreens_id = Item.id;
          }
       }

        free_items_list.push(42547158876294);
        free_items_list.push(42547159335046);
        if($switch_power_perform == true){
          UnlockedItem.push(42547158876294); // 500ml Switch Bottle
          UnlockedItem.push(42547159335046); // Switch Perform Towel
        }
        
        free_items_list.push(42549125316742);
        free_items_list.push(43121434329222);
        if($nexus_juicy_burst == true){
          UnlockedItem.push(42549125316742); // Nexus Creatine Monohydrate
          UnlockedItem.push(43121434329222); // Nexus Shaker
        }

        free_items_list.push(42170711146630);
        free_items_list.push(43135813386374);
        if($Ehp_total > 9900){
          UnlockedItem.push(42170711146630); // EHP x Elite 800ml Shaker
          UnlockedItem.push(43135813386374); // Oxygreens Pineapple
          // if($oxygreens_status == false){
          //   $('.whey-freebie-wrapper').addClass('open-whey-offer')
          //   $('.whey-freebie-drawer').addClass('open-drawer')
          //   document.body.classList.add('overflow-hidden');
          // }else{
          //   UnlockedItem.push($oxygreens_id); // OxyGreens
          // }
        }
      
        free_items_list.push(41614239236230);
        if($krupt == true){
          UnlockedItem.push(41614239236230); // krupt duffel bag
        }

        free_items_list.push(40014980808838);
        if($max_shred_system == true){
          UnlockedItem.push(40014980808838); // Max's Creatine Monohydrate 400g
        }
      
       if(onlygift == false){
          if(total_price > 39999 && $400_deal_found == false){
            $('.gift_product_slider').hide();
            $('.gift_product_slider[data-target=400-deal-bar]').show();
            $("#gift_popup").removeClass("rule-1-deal-popup").show();
            UnlockedItem.push(Product5);
            UnlockedItem.push(Product4);
            UnlockedItem.push(Product1);
          }else if(total_price > 17999){
            UnlockedItem.push(Product5);
            UnlockedItem.push(Product1);
          }else if(total_price > 10999){
            UnlockedItem.push(Product1);
          }
          free_items_list.push(40650382901382);
            if(total_price > 39999 && $400_deal_found == true){
              UnlockedItem.push(Product1),UnlockedItem.push(Product3);
            }

         $('.insurance-wrapper-main').show();
       }else{
         $('.insurance-wrapper-main').hide();
       }
      for(var i=0; i < Items.length;i++){
        var Item = Items[i];
        if(Item.id == Product0 || Item.id == Product1 || Item.id == Product2 || Item.id == Product3 || Item.id == Product4 || Item.id == Product5 || jQuery.inArray(Item.id,free_items_list) != -1){
          if(Item.properties && Item.properties['_free-product']){
           ExfreeItem.push(Item.id);
          }
          if(Item.properties && Item.properties['_free-with_nexus_juicy_burst']){
           ExfreeItem.push(Item.id);
          }
          if(Item.properties && Item.properties['_free-with_atp_science']){
           ExfreeItem.push(Item.id);
          }
          if(Item.properties && Item.properties['_free-with_60g_shilajit']){
           ExfreeItem.push(Item.id);
          }
          if(Item.properties && Item.properties['_free-with_disorder_ultimate']){
           ExfreeItem.push(Item.id);
          }
          if(Item.properties && Item.properties['_free-with_nexus_per4m']){
           ExfreeItem.push(Item.id);
          }
          if(Item.properties && Item.properties['_free-with_villain']){
           ExfreeItem.push(Item.id);
          }
          if(Item.properties && Item.properties['_free-with_nitro_tech']){
           ExfreeItem.push(Item.id);
          }
          if(Item.properties && Item.properties['_free-with_max_shred_system']){
           ExfreeItem.push(Item.id);
          }
          if(Item.properties && Item.properties['_free-with_dialed_carnage']){
           ExfreeItem.push(Item.id);
          }
          if(Item.properties && Item.properties['_free-with_elite_exclusive_end_of_dayz']){
           ExfreeItem.push(Item.id);
          }
          if(Item.properties && Item.properties['_free-with_spend_150']){
           ExfreeItem.push(Item.id);
          }
          if(Item.properties && Item.properties['_free-with_on_spend_200']){
           ExfreeItem.push(Item.id);
          }
          if(Item.properties && Item.properties['_free-with_zombie_endofdays']){
           ExfreeItem.push(Item.id);
          }
          if(Item.properties && Item.properties['_free-with_r1_protein_5lb']){
           ExfreeItem.push(Item.id);
          }
          if(Item.properties && Item.properties['_free-with_switch_power_perform']){
           ExfreeItem.push(Item.id);
          }
          if(Item.properties && Item.properties['_free-with_EHPLabs_spend_99']){
           ExfreeItem.push(Item.id);
          }
          if(Item.quantity > 1){
           NeedtoRemove.push(Item.id);
           Rp.updates[Item.id] = 1;
          }
         }
       }

       var $eligible_rtd = parseInt($mystery_stack/3);
      //  console.log("$eligible_rtd",$eligible_rtd);
       if($eligible_rtd){
        if($free_rtd_count == 0){
          NeedtoAdd.push($mystery_rtd);
        } else{
          if($free_rtd_count != $eligible_rtd){
            NeedtoRemove.push($eligible_rtd);
            Rp.updates[$mystery_rtd] = $eligible_rtd;
          }
        }
       }else{
          if($free_rtd_count > 0){
            NeedtoRemove.push($mystery_rtd);
            Rp.updates[$mystery_rtd] = 0;
          }
       }

      for(var j=0; j < ExfreeItem.length; j++){
         var Ex = ExfreeItem[j];
         if(onlygift){
           Needtoupdate = true;
           NeedtoRemove.push(Ex);
           Rp.updates[Ex] = 0;
         }else{
           if(jQuery.inArray(Ex,UnlockedItem) == -1){
             Needtoupdate = true;
             NeedtoRemove.push(Ex);
             Rp.updates[Ex] = 0;
           }
         }
       }
      
      for(var k=0; k < UnlockedItem.length; k++){
         var Fr = UnlockedItem[k];
         if(jQuery.inArray(Fr,ExfreeItem) == -1){
           Needtoupdate = true;
           if(cart.attributes && cart.attributes[Fr] == "removed"){
           }else{
             NeedtoAdd.push(Fr);
           }
         }
       }

      if(Needtoupdate){ }
       if(NeedtoRemove.length){
          Rp.sections_url = window.location.pathname;
          Rp.sections = _this.getSectionsToRender().map((section) => section.section);
          // return;
          fetch('/cart/update.js', { method: 'POST',headers: {'Content-Type': 'application/json'}, body: JSON.stringify(Rp)}).then(response => {
              return response.text();
          }).then((state) => {
            const parsedState = JSON.parse(state);
            window.cart = parsedState;
            if(NeedtoAdd.length){
             this.ADDTOCART(NeedtoAdd);
            } else{
             _this.CARTUPDATE(parsedState);
            }
          });
       }else if(NeedtoAdd.length){
         this.ADDTOCART(NeedtoAdd);
       }
    });
  }

  ADDTOCART(Products){
    var _this = this;
     if(Products.length){
       let formData = { 'items': [] };
           formData.sections_url = window.location.pathname;
           formData.sections = _this.getSectionsToRender().map((section) => section.section);
      //  console.log("Products",Products);
       var $mystery_rtd = 42176760479878;
       for(var i=0; i < Products.length; i++){
        if(Products[i]){
          if(Products[i] == 41274459455622){
          // formData.items.push({ 'id': Products[i],'quantity': 1, properties:{'_free_giveaway':'true'} })
            formData.items.push({ 'id': Products[i],'quantity': 1 })
          } else if(Products[i] == 42524208857222 || Products[i] == 42483116769414 || Products[i] == 42483116802182 || Products[i] == 42483116834950){
            formData.items.push({ 'id': Products[i],'quantity': 1, properties:{'_free-with_zombie_endofdays':'true'} })
          } else if(Products[i] == $mystery_rtd){
            formData.items.push({ 'id': Products[i],'quantity': 1, properties:{'_free-with_mystery_product_stack':'true'} })
          } else if(Products[i] == 41557265350790 || Products[i] == 40124394406022 || Products[i] == 41095667548294){
            formData.items.push({ 'id': Products[i],'quantity': 1, properties:{'_free-with_disorder_ultimate':'true'} })
          } else if(Products[i] == 42547132661894 || Products[i] == 42547138625670){
            formData.items.push({ 'id': Products[i],'quantity': 1, properties:{'_free-with_r1_protein_5lb':'true'} })
          } else if(Products[i] == 42547159335046 || Products[i] == 42547158876294){
            formData.items.push({ 'id': Products[i],'quantity': 1, properties:{'_free-with_switch_power_perform':'true'} })
          } else if(Products[i] == 43121434329222 || Products[i] == 42549125316742){
            formData.items.push({ 'id': Products[i],'quantity': 1, properties:{'_free-with_nexus_juicy_burst':'true'} })
          } else if(Products[i] == 42130379243654 || Products[i] == 42130393432198){
            formData.items.push({ 'id': Products[i],'quantity': 1, properties:{'_free-with_nexus_per4m':'true'} })
          } else if(Products[i] == 41509747720326){
            formData.items.push({ 'id': Products[i],'quantity': 1, properties:{'_free-with_60g_shilajit':'true'} })
          } else if(Products[i] == 41614239236230){
            formData.items.push({ 'id': Products[i],'quantity': 1, properties:{'_free-with_villain':'true'} })
          } else if(Products[i] == 41460243824774){
            formData.items.push({ 'id': Products[i],'quantity': 1, properties:{'_free-with_on_spend_200':'true'} })
          } else if(Products[i] == 41575756202118 || Products[i] == 41575756234886){
            formData.items.push({ 'id': Products[i],'quantity': 1, properties:{'_free-with_atp_science':'true'} })
          } else if(Products[i] == 41689721700486 || Products[i] == 41689573064838){
            formData.items.push({ 'id': Products[i],'quantity': 1, properties:{'_free-with_nitro_tech':'true'} })
          } else if(Products[i] == 40014980808838){
            formData.items.push({ 'id': Products[i],'quantity': 1, properties:{'_free-with_max_shred_system':'true'} })
          } else if(Products[i] == 41570310324358){
            formData.items.push({ 'id': Products[i],'quantity': 1, properties:{'_free-with_dialed_carnage':'true'} }) 
          } else if(Products[i] == 42022235897990){
            formData.items.push({ 'id': Products[i],'quantity': 1, properties:{'_free-with_elite_exclusive_end_of_dayz':'true'} })
          } else if(Products[i] == 42170711146630 || Products[i] == 43135813386374){
            formData.items.push({ 'id': Products[i],'quantity': 1, properties:{'_free-with_EHPLabs_spend_99':'true'} }) 
          }else{
            formData.items.push({ 'id': Products[i],'quantity': 1, properties:{'_free-product':'true'} })
          }
        }
       }
       if(formData.items.length){
          fetch('/cart/add.js', { method: 'POST',headers: {'Content-Type': 'application/json'}, body: JSON.stringify(formData)}).then(response => {
              return response.text();
          }).then((state) => {
            const parsedState = JSON.parse(state);
            _this.CARTUPDATE(parsedState);
         });
       }
     }
  }

  CARTUPDATE(parsedState){
    localStorage.setItem("cart_data",JSON.stringify(parsedState));
    var _this = this;
    _this.classList.toggle('is-empty', parsedState.item_count === 0);
    const cartDrawerWrapper = document.querySelector('cart-drawer');
    const cartFooter = document.getElementById('main-cart-footer');

    if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
    if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

    _this.getSectionsToRender().forEach((section) => {
      const elementToReplace =
        document.getElementById(section.id)?.querySelector(section.selector) || document.getElementById(section.id);
        if(elementToReplace){
          elementToReplace.innerHTML = _this.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector
          );
        }
    });
    if(window.location.search == '?view=cashback' || window.location.pathname == "/account/login"){
      
    } else{
      CartDrawer = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      CartDrawer.classList.add('animate', 'active');
    }
    fetch('/cart.js').then(res => res.json()).then((cart) => {
      window.cart = cart;
    });
  }
  
  FBT(){
    if(window.FBTCalled == false){
        var _this = this;
        window.UpdateCart = function(){
          fetch('/cart.js').then(res => res.json()).then((cart) => {
              if(cart.item_count == 0) return;
              var line = 1;
              var quantity = cart.items[0].quantity;
              const body = JSON.stringify({
                line,
                quantity,
                sections: _this.getSectionsToRender().map((section) => section.section),
                sections_url: window.location.pathname
              });
    
              fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
              .then((response) => {
                return response.text();
              })
              .then((state) => {
                const parsedState = JSON.parse(state);
                _this.CARTUPDATE(parsedState);
              });
          });
        }

        window.add_NostoFBT_to_cart = function(Items,$this){
          // console.log("add_NostoFBT_to_cart",Items);
          // console.log("$this",$this);
          // $this.addClass("loading").prop( 'disabled', true ).find('.loading__spinner').removeClass("hidden");
          let formData = Items;
          formData.sections_url = window.location.pathname;
          formData.sections = _this.getSectionsToRender().map((section) => section.section);
          fetch('/cart/add.js', { method: 'POST',headers: {'Content-Type': 'application/json'}, body: JSON.stringify(formData)}).then(response => {
                return response.text();
            }).then((state) => {
              const parsedState = JSON.parse(state);
              // console.log("parsedState",parsedState);
              $('.nosto-add-bundle').removeClass("loading").prop( 'disabled', false ).find('.loading__spinner').addClass("hidden");
              const cartDrawerWrapper = document.querySelector('cart-drawer');
              const cartFooter = document.getElementById('main-cart-footer');
              if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.items.length === 0);
              if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.items.length === 0);
              _this.getSectionsToRender().forEach((section) => {
                const elementToReplace =
                  document.getElementById(section.id)?.querySelector(section.selector) || document.getElementById(section.id);
                  if(elementToReplace){
                    elementToReplace.innerHTML = _this.getSectionInnerHTML(
                      parsedState.sections[section.section],
                      section.selector
                    );
                  }
              });
              if(window.location.search == '?view=cashback' || window.location.pathname == "/account/login"){
              } else{
                CartDrawer = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
                CartDrawer.classList.add('animate', 'active');
              }
            });
        }
        
        window.FBTCalled = true;
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        $(document).on('click', '.fbt_atc', function() {
          var $this = $(this);
          $this.addClass("loading").prop( 'disabled', true ).find('.loading__spinner').removeClass("hidden");
          let formData = { 'items': [] };
          formData.sections_url = window.location.pathname;
          formData.sections = _this.getSectionsToRender().map((section) => section.section);
          var d = "_elite_"+Date.now();
          $(".fbt_product").each(function(){
            var $option = $(this).find("select").find("option:selected");
            formData.items.push({ 'id': $option.val(), 'quantity': 1, properties: { '_elite_recommends': d } })
          });
          if(formData.items.length){
            fetch('/cart/add.js', { method: 'POST',headers: {'Content-Type': 'application/json'}, body: JSON.stringify(formData)}).then(response => {
                return response.text();
            }).then((state) => {
              const parsedState = JSON.parse(state);
              _this.CARTUPDATE(parsedState);
              $this.removeClass("loading").prop( 'disabled', false ).find('.loading__spinner').addClass("hidden");
            });
          }
      });

        $(document).on('click', '.free-atc-btn', function() {
          var $this = $(this);
          $this.addClass("loading").prop( 'disabled', true ).find('.loading__spinner').removeClass("hidden");
          let formData = { 'items': [] };
          formData.sections_url = window.location.pathname;
          formData.sections = _this.getSectionsToRender().map((section) => section.section);
          formData.items.push({ 'id': $this.data('variant'), 'quantity': 1, properties: { '_free-product': 'true' } });
          formData.attributes = { [$this.data('variant')]:"added"};
          fetch('/cart/add.js', { method: 'POST',headers: {'Content-Type': 'application/json'}, body: JSON.stringify(formData)}).then(response => {
              return response.text();
          }).then((state) => {
            const parsedState = JSON.parse(state);
            _this.CARTUPDATE(parsedState);
          });
      })

      $(document).on('click', '.gift-whey-atc', function() {
          $('.gift-whey-atc').prop( 'disabled', true );
          var $this = $(this);
          var $target = '_'+$this.parents('.gift_product_slider').data('target');
          var $properties = {};
          $properties[$target] = "true";
          $properties["_free-product"] = "true";
          $this.addClass("loading").prop( 'disabled', true ).find('.loading__spinner').removeClass("hidden");
          let formData = { 'items': [] };
          formData.sections_url = window.location.pathname;
          formData.sections = _this.getSectionsToRender().map((section) => section.section);
          formData.items.push({ 'id': $this.data('variant'), 'quantity': 1, properties: $properties });
          fetch('/cart/add.js', { method: 'POST',headers: {'Content-Type': 'application/json'}, body: JSON.stringify(formData)}).then(response => {
              return response.text();
          }).then((state) => {
            const parsedState = JSON.parse(state);
            $this.removeClass("loading").prop( 'disabled', false).find('.loading__spinner').addClass("hidden");
            $('#gift_popup').hide();
            $('.gift-whey-atc').prop( 'disabled', false );
            _this.CARTUPDATE(parsedState);
          });
      });

      $(document).on('click', '.whey-freebie-atc', function() {
          $('.whey-freebie-atc').prop( 'disabled', true );
          var $this = $(this);
          $this.addClass("loading").prop( 'disabled', true ).find('.loading__spinner').removeClass("hidden");
          let formData = { 'items': [] };
          formData.sections_url = window.location.pathname;
          formData.sections = _this.getSectionsToRender().map((section) => section.section);
          formData.items.push({ 'id': $this.data('variant'), 'quantity': 1, properties:{ '_free-with_EHPLabs_spend_99': 'true' } });
          fetch('/cart/add.js', { method: 'POST',headers: {'Content-Type': 'application/json'}, body: JSON.stringify(formData)}).then(response => {
              return response.text();
          }).then((state) => {
            const parsedState = JSON.parse(state);
            $this.removeClass("loading").prop( 'disabled', false).find('.loading__spinner').addClass("hidden");
            $('.whey-freebie-wrapper').removeClass('open-whey-offer')
            $('.whey-freebie-drawer').removeClass('open-drawer')
            document.body.classList.remove('overflow-hidden');
            $('.whey-freebie-atc').prop( 'disabled', false );
            _this.CARTUPDATE(parsedState);
          });
      });
    }
  }

  DealBar(){
    if(window.DealBarCalled == false){
      window.DealBarCalled = true;
      var _this = this;
      $(document).on("click",".upsell-atc",function(){
        var $this = $(this);
          $this.addClass("loading").prop( 'disabled', true ).find('.loading__spinner').removeClass("hidden");
          let formData = { 'items': [] };
          formData.sections_url = window.location.pathname;
          formData.sections = _this.getSectionsToRender().map((section) => section.section);
            var $variant = $(this).parent().find("select").val();
            formData.items.push({ 'id': $variant, 'quantity': 1, properties: { '_exclusive-checkout-deals': 'true' } })
              fetch('/cart/add.js', { method: 'POST',headers: {'Content-Type': 'application/json'}, body: JSON.stringify(formData)}).then(response => {
                  return response.text();
              }).then((state) => {
                const parsedState = JSON.parse(state);
                _this.CARTUPDATE(parsedState);
                $this.removeClass("loading").prop( 'disabled', false ).find('.loading__spinner').addClass("hidden");
                $this.find('span').html("ADDED TO CART");
                setTimeout(function(){
                  $this.find('span').html("ADD TO CART");
                },2000)
             }).catch((e) => {
                console.log("error",e);
                console.error(e);
             });
      });


    }
  }
  
  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  onChange(event) {
    this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'), event.target.dataset.quantityVariantId);
  }

  onCartUpdate() {
    if (this.tagName === 'CART-DRAWER-ITEMS') {
      fetch(`${routes.cart_url}?section_id=cart-drawer`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const selectors = ['cart-drawer-items', '.cart-drawer__footer'];
          for (const selector of selectors) {
            const targetElement = document.querySelector(selector);
            const sourceElement = html.querySelector(selector);
            if (targetElement && sourceElement) {
              targetElement.replaceWith(sourceElement);
            }
          }
        })
        .catch((e) => {
          console.error(e);
        });
    } else {
      fetch(`${routes.cart_url}?section_id=main-cart-items`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const sourceQty = html.querySelector('cart-items');
          this.innerHTML = sourceQty.innerHTML;
        })
        .catch((e) => {
          console.error(e);
        });
    }
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section',
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'announcement-bar-cart-deal',
        section: 'announcement-bar-cart-deal',
        selector: '.ab-cart-header-information',
      },
    ];
  }

  updateQuantity(line, quantity, name, variantId) {
    GA4.added_or_removed(line-1, quantity);
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        const quantityElement =
          document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
        const items = document.querySelectorAll('.cart-item');

        if (parsedState.errors) {
          quantityElement.value = quantityElement.getAttribute('value');
          this.updateLiveRegions(line, parsedState.errors);
          return;
        }

        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector('cart-drawer');
        const cartFooter = document.getElementById('main-cart-footer');

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
        if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

        this.getSectionsToRender().forEach((section) => {
          const elementToReplace =
            document.getElementById(section.id)?.querySelector(section.selector) || document.getElementById(section.id);
          if(elementToReplace){
            elementToReplace.innerHTML = this.getSectionInnerHTML(
              parsedState.sections[section.section],
              section.selector
            );
          }
        });
        const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
        let message = '';
        if (items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement.value)) {
          if (typeof updatedValue === 'undefined') {
            message = window.cartStrings.error;
          } else {
            message = window.cartStrings.quantityError.replace('[quantity]', updatedValue);
          }
        }
        this.updateLiveRegions(line, message);

        const lineItem =
          document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper
            ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`))
            : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'));
        } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'));
        }

        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: parsedState, variantId: variantId });
      })
      .catch(() => {
        this.querySelectorAll('.loading__spinner').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        errors.textContent = window.cartStrings.error;
      })
      .finally(() => {
        this.disableLoading(line);
      });
  }

  updateQuantity_For_Gift($id,line) {
    this.enableLoading(line);
    var _this = this;
    var data = { updates: {} };
    data.updates[$id] = '0';
    data.attributes = { [$id]:"removed"};
    data.sections = this.getSectionsToRender().map((section) => section.section);
    data.sections_url = window.location.pathname;

    fetch('/cart/update.js', { method: 'POST',headers: {'Content-Type': 'application/json'}, body: JSON.stringify(data)}).then(response => {
        return response.text();
    }).then((state) => {
      const parsedState = JSON.parse(state);
      _this.CARTUPDATE(parsedState);
    });

    return;
    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        const quantityElement =
          document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
        const items = document.querySelectorAll('.cart-item');

        if (parsedState.errors) {
          quantityElement.value = quantityElement.getAttribute('value');
          this.updateLiveRegions(line, parsedState.errors);
          return;
        }

        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector('cart-drawer');
        const cartFooter = document.getElementById('main-cart-footer');

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
        if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

        this.getSectionsToRender().forEach((section) => {
          const elementToReplace =
            document.getElementById(section.id)?.querySelector(section.selector) || document.getElementById(section.id);
          elementToReplace.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector
          );
        });
        const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
        let message = '';
        if (items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement.value)) {
          if (typeof updatedValue === 'undefined') {
            message = window.cartStrings.error;
          } else {
            message = window.cartStrings.quantityError.replace('[quantity]', updatedValue);
          }
        }
        this.updateLiveRegions(line, message);

        const lineItem =
          document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper
            ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`))
            : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'));
        } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'));
        }

        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: parsedState, variantId: variantId });
      })
      .catch(() => {
        this.querySelectorAll('.loading__spinner').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        errors.textContent = window.cartStrings.error;
      })
      .finally(() => {
        this.disableLoading(line);
      });
  }
  
  updateLiveRegions(line, message) {
    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError) lineItemError.querySelector('.cart-item__error-text').innerHTML = message;

    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus =
      document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.remove('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    cartItemElements.forEach((overlay) => overlay.classList.add('hidden'));
    cartDrawerItemElements.forEach((overlay) => overlay.classList.add('hidden'));
  }

  Checkproduct(cart){
    var _this = this;
      var items = cart.items;
      items.forEach(function(i,v){
        // Purple Dot required change
        // Don't remove the insurance product if on the /cart page, as this is where Purple Dot
        // will mount its checkout. Otherwise, the insurance product will always be removed for pre-orders.
        if(i.product_id == InsuranceData.product_id && !window.location.href.includes('/cart')){
        // if(i.product_id == InsuranceData.product_id){
          var variant_id = i.id;
          var data = { updates: {} };
          data.updates[variant_id] = '0';
          data.sections_url = window.location.pathname;
          data.sections = _this.getSectionsToRender().map((section) => section.section);
          fetch('/cart/update.js', { method: 'POST',headers: {'Content-Type': 'application/json'}, body: JSON.stringify(data)}).then(response => {
              return response.text();
          }).then((state) => {
            const parsedState = JSON.parse(state);
            window.cart = parsedState;
            _this.CARTUPDATE(parsedState);
          });
        }
      });
  }
  
}

customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
  customElements.define(
    'cart-note',
    class CartNote extends HTMLElement {
      constructor() {
        super();

        this.addEventListener(
          'change',
          debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
          }, ON_CHANGE_DEBOUNCE_TIMER)
        );
      }
    }
  );
}

var InsuranceData = {
  "product_id": 4383275614296,
  "basic_variant": 31676161654872,
  "threshold_price": 100.00,
  "basic_variant": 31676161654872,
  "basic_price": 1.98,
  "variants": [{"name":"Basic Shipping Protection","price":"1.98","id":31676161654872},{"name":"A$2.42","price":"2.42","id":31676161687640},{"name":"A$2.53","price":"2.53","id":31676161720408},{"name":"A$2.65","price":"2.65","id":31676161753176},{"name":"A$2.76","price":"2.76","id":31676161785944},{"name":"A$2.88","price":"2.88","id":31676161851480},{"name":"A$2.99","price":"2.99","id":31676161884248},{"name":"A$3.11","price":"3.11","id":31676161917016},{"name":"A$3.22","price":"3.22","id":31676161949784},{"name":"A$3.34","price":"3.34","id":31676161982552},{"name":"A$3.45","price":"3.45","id":31676162015320},{"name":"A$3.57","price":"3.57","id":31676162048088},{"name":"A$3.68","price":"3.68","id":31676162080856},{"name":"A$3.80","price":"3.8","id":31676162113624},{"name":"A$3.91","price":"3.91","id":31676162146392},{"name":"A$4.03","price":"4.03","id":31676162179160},{"name":"A$4.14","price":"4.14","id":31676162211928},{"name":"A$4.26","price":"4.26","id":31676162244696},{"name":"A$4.37","price":"4.37","id":31676162277464},{"name":"A$4.49","price":"4.49","id":31676162310232},{"name":"A$4.60","price":"4.6","id":31676162343000},{"name":"A$4.78","price":"4.78","id":31676162375768},{"name":"A$4.97","price":"4.97","id":31676162408536},{"name":"A$5.15","price":"5.15","id":31676162441304},{"name":"A$5.34","price":"5.34","id":31676162474072},{"name":"A$5.52","price":"5.52","id":31676162506840},{"name":"A$5.70","price":"5.7","id":31676162572376},{"name":"A$5.89","price":"5.89","id":31676162605144},{"name":"A$6.07","price":"6.07","id":31676162637912},{"name":"A$6.26","price":"6.26","id":31676162703448},{"name":"A$6.44","price":"6.44","id":31676162768984},{"name":"A$6.62","price":"6.62","id":31676162801752},{"name":"A$6.81","price":"6.81","id":31676162834520},{"name":"A$7.08","price":"7.08","id":31676162867288},{"name":"A$7.36","price":"7.36","id":31676162900056},{"name":"A$7.64","price":"7.64","id":31676162932824},{"name":"A$7.91","price":"7.91","id":31676162965592},{"name":"A$8.19","price":"8.19","id":31676162998360},{"name":"A$8.46","price":"8.46","id":31676163031128},{"name":"A$8.74","price":"8.74","id":31676163063896},{"name":"A$9.02","price":"9.02","id":31676163096664},{"name":"A$9.48","price":"9.48","id":31676163129432},{"name":"A$9.94","price":"9.94","id":31676163162200},{"name":"A$10.40","price":"10.4","id":31676163194968},{"name":"A$10.86","price":"10.86","id":31676163227736},{"name":"A$11.32","price":"11.32","id":31676163260504},{"name":"A$12.01","price":"12.01","id":31676163293272},{"name":"A$12.70","price":"12.7","id":31676163326040},{"name":"A$13.39","price":"13.39","id":31676163358808},{"name":"A$14.08","price":"14.08","id":31676163391576},{"name":"A$14.77","price":"14.77","id":31676163424344},{"name":"A$15.46","price":"15.46","id":31676163457112},{"name":"A$16.15","price":"16.15","id":31676163489880},{"name":"A$16.84","price":"16.84","id":31676163522648},{"name":"A$17.53","price":"17.53","id":31676163555416},{"name":"A$18.22","price":"18.22","id":31676163588184},{"name":"A$18.91","price":"18.91","id":31676163620952},{"name":"A$19.60","price":"19.6","id":31676163653720},{"name":"A$20.29","price":"20.29","id":31676163686488},{"name":"A$20.98","price":"20.98","id":31676163948632},{"name":"A$21.67","price":"21.67","id":31676164014168},{"name":"A$22.36","price":"22.36","id":31676164079704},{"name":"A$23.05","price":"23.05","id":31676164145240},{"name":"A$25.35","price":"25.35","id":31676164210776},{"name":"A$27.65","price":"27.65","id":31676164276312},{"name":"A$29.95","price":"29.95","id":31676164341848},{"name":"A$32.25","price":"32.25","id":31676164440152},{"name":"A$34.55","price":"34.55","id":31676164505688},{"name":"A$36.85","price":"36.85","id":31676164571224},{"name":"A$39.15","price":"39.15","id":31676164669528},{"name":"A$41.45","price":"41.45","id":31676164702296},{"name":"A$43.75","price":"43.75","id":31676164735064},{"name":"A$46.05","price":"46.05","id":31676164767832},{"name":"A$55.25","price":"55.25","id":31676164800600},{"name":"A$59.85","price":"59.85","id":31676164833368},{"name":"A$64.45","price":"64.45","id":31676164866136},{"name":"A$69.05","price":"69.05","id":39807153471622},{"name":"A$78.25","price":"78.25","id":39807153504390},{"name":"A$87.45","price":"87.45","id":39807153537158},{"name":"A$96.65","price":"96.65","id":39807153569926},{"name":"A$105.85","price":"105.85","id":39807153602694},{"name":"A$115.05","price":"115.05","id":39807153635462},{"name":"A$126.55","price":"126.55","id":39807153668230},{"name":"A$138.05","price":"138.05","id":39807153700998},{"name":"A$149.55","price":"149.55","id":39807153733766},{"name":"A$161.05","price":"161.05","id":39807153766534},{"name":"A$172.55","price":"172.55","id":39807153799302},{"name":"A$184.05","price":"184.05","id":39807153832070},{"name":"A$195.55","price":"195.55","id":39807153864838},{"name":"A$207.05","price":"207.05","id":39807153897606},{"name":"A$218.55","price":"218.55","id":39807153930374}]
}

var EliteProtection = {
  Init: function(){
    fetch('/cart.js').then(res => res.json()).then((cart) => {
      EliteProtection.InitWithCart(cart);
    });
  },
  InitWithCart: function(cart){
    var cart_total = 0,
        InsuranceValue = 0,
        Protectionstatus = EliteProtection.getCookie('Protectionstatus');
    for(t=0; t < cart.items.length; t++){
      if(cart.items[t].handle != 'gift-card'){
        cart_total = cart_total+cart.items[t].final_line_price;
      }
    }
		cart_total = cart_total/100;
    if(cart_total > InsuranceData.threshold_price){
      var value = EliteProtection.getClosests(cart_total,InsuranceData.variants);
      $('#insurancePrice').html(Shopify.formatMoney(value.price*100,Shopify.money_format));
      if(Protectionstatus == "true"){
        InsuranceValue = value.price
      }
    }else{
      $('#insurancePrice').html(Shopify.formatMoney(InsuranceData.basic_price*100,Shopify.money_format));
      if(Protectionstatus == "true"){
        InsuranceValue = InsuranceData.basic_price;
      }
    }

    var CartTotal_with_insurance = parseFloat(cart.total_price);
    if(Protectionstatus == "true"){
      $('#easy-protection').prop("checked", true);
      CartTotal_with_insurance = CartTotal_with_insurance + parseFloat(InsuranceValue*100);
    }else{
      $('#easy-protection').prop("checked", false); 
    }
    var onlygift = true;
    for(i=0; i < cart.items.length;i++){
      var Item = cart.items[i];
      if(Item.handle != 'gift-card'){
        if(Item.properties && Item.properties['_free-product']){
        }else{
          onlygift = false;
        }
      }
    }
    
    if(onlygift){
      cart_total = (Math.abs(parseFloat(cart_total)))*100;
    }else{
      cart_total = (Math.abs(parseFloat(cart_total)+parseFloat(InsuranceValue)))*100;
    }
    $('.totals__total-value').html(Shopify.formatMoney(CartTotal_with_insurance,Shopify.money_format)+" AUD");
    
    const earningPrice = cart.total_price * 0.05;
    $('.earning-text span').html(Shopify.formatMoney(earningPrice,Shopify.money_format));
  },
  AddToCard: function(variant){
    let formData = { 'items': [{ 'id': variant,'quantity': 1 }] };
    fetch('/cart/add.js', { method: 'POST', headers: {'Content-Type': 'application/json'}, body: JSON.stringify(formData)}).then(response => {
      // window.location.href = '/checkout';
      // Purple dot change
      navigateToCheckout();
    }).catch((error) => {
      // window.location.href = '/checkout';
      // Purple dot change
      navigateToCheckout();
    });
  },
  getClosests: function getClosests(total, variants) {
    var counts = variants,
        goal = total*2.3/100;
    var closest = counts.reduce(function(prev, curr) {
      return Math.abs(parseFloat(curr.price) - parseFloat(goal)) < Math.abs(parseFloat(prev.price) - goal) ? curr : prev;
    });
    return closest;
  },
  CookieInit: function(){
    var Protectionstatus = EliteProtection.getCookie('Protectionstatus');
    if(Protectionstatus == null){
      document.cookie = "Protectionstatus=true";
    }
  }, 
  getCookie: function(name){
    var cookieArr = document.cookie.split(";");
    for(var i = 0; i < cookieArr.length; i++) {
      var cookiePair = cookieArr[i].split("=");
      if(name == cookiePair[0].trim()) {
        return decodeURIComponent(cookiePair[1]);
      }
    }
    return null;
  }
}

$(document).on('change', '#easy-protection', function(){
  if($(this).prop("checked") == true){
    document.cookie = "Protectionstatus=true";
  } else{
    document.cookie = "Protectionstatus=false";
  }
  EliteProtection.Init(); 
});

window.onload = function () {
  EliteProtection.CookieInit();
}

$(document).on("click","#CartDrawer-Checkout",function(e) {
  e.stopPropagation();
  e.preventDefault();
  $(this).html("Loading Checkout <span class='dot-typing'></span>");
  var EasyStatus = EliteProtection.getCookie('Protectionstatus');
    if(EasyStatus && EasyStatus == "true"){
      e.stopPropagation();
      e.preventDefault();
      fetch('/cart.js').then(res => res.json()).then((cart) => {
        var cart_total = 0,
            InsuranceValue = 0,
            onlygift = true;
        
        for(t=0; t < cart.items.length; t++){
          if(cart.items[t].handle != 'gift-card'){
            cart_total = cart_total+cart.items[t].final_line_price;
          }
        }
        cart_total = cart_total/100;
        
        for(i=0; i < cart.items.length;i++){
          var Item = cart.items[i];
          if(Item.handle != 'gift-card'){
            if(Item.properties && Item.properties['_free-product']){
            }else{
              onlygift = false;
            }
          }
        }
        
        if(cart_total > InsuranceData.threshold_price){
          var InsuranceVariant = EliteProtection.getClosests(cart_total,InsuranceData.variants);
          InsuranceVariant = InsuranceVariant.id;
        }else{
          InsuranceVariant = InsuranceData.basic_variant;
        }
        if(onlygift){
          // window.location.href = '/checkout';
          // Purple dot change
          navigateToCheckout()
        }else{
          EliteProtection.AddToCard(InsuranceVariant);
        }
        
      });
    }else{
      // window.location.href = '/checkout';
      // Purple dot change
      navigateToCheckout()
    }
  setTimeout(function(){
    // window.location.href = '/checkout';
    // Purple dot change
    navigateToCheckout()
  },7000);
});

// Purple Dot required change
// Purple Dot's integration mounts its checkout on top of the /cart page. This checks
// the cart for the presence of an item on pre-order and redirects to /cart if necessary.
// Otherwise, it redirects to the native Shopify /checkout.
async function navigateToCheckout() {
  const cart = await fetch('/cart.js').then(res => res.json());
  
  let hasPreorder = false;
  for (let item of cart.items) {
    if (item.properties && item.properties['__releaseId']) {
      hasPreorder = true;
    }
  }

  if (hasPreorder) {
    window.location.href = '/cart';
  } else {
    window.location.href = '/checkout';
  }
}